<template>
<div class="chapter">
<div class="inner_page">
<p class="hlf"><a id="page_i"></a><strong>THE RECKONING</strong><a id="page_ii"></a></p>
<p class="break"> </p>
<p class="hlf"><a id="page_iii"></a><a id="tit"></a><strong>THE RECKONING</strong></p>
<p class="tit1"><strong>DEBT, DEMOCRACY, AND THE FUTURE OF AMERICAN POWER</strong></p>
<p class="auth"><strong>MICHAEL MORAN</strong></p>
<p class="auth1"><em>Foreword by Dr. Nouriel Roubini</em></p>
<p class="image-tit"><img alt="image" src="html/images/title.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780230339934_01_Prexiv.vue?7bde8d86